import TuneIcon from "@mui/icons-material/Tune";
import { FILTER_MENU_OPTIONS, SORT_MENU_OPTIONS } from "../constants";
import type { FilterKey, SortKey } from "../types";
import { MatchesDropdown } from "./MatchesDropdown";

export const MatchesToolbar = ({
  isMobile,
  appliedFilter,
  counts,
  sortOption,
  mobileFiltersOpen,
  onToggleMobileFilters,
  onFilterChange,
  onSortChange,
}: {
  isMobile: boolean;
  appliedFilter: FilterKey;
  counts: {
    all: number;
    loves: number;
    likes: number;
    notForMe: number;
    online: number;
  };
  sortOption: SortKey;
  mobileFiltersOpen: boolean;
  onToggleMobileFilters: () => void;
  onFilterChange: (next: FilterKey) => void;
  onSortChange: (next: SortKey) => void;
}) => {
  if (isMobile) {
    return (
      <div className="matches-mobile-toolbar" aria-label="Match filters">
        <div className="matches-mobile-pill-row">
          {[
            { key: "all", label: "All", count: counts.all },
            { key: "loves", label: "Loves", count: counts.loves },
            { key: "likes", label: "Likes", count: counts.likes },
            { key: "not_for_me", label: "Not for Me", count: counts.notForMe },
          ].map((pill) => (
            <button
              key={pill.key}
              type="button"
              className={`matches-pill ${appliedFilter === pill.key ? "is-active" : ""}`}
              onClick={() => onFilterChange(pill.key as FilterKey)}
              aria-pressed={appliedFilter === pill.key}
            >
              <span>{pill.label}</span>
              <span className="matches-pill-count">{pill.count}</span>
            </button>
          ))}
        </div>
        <button
          type="button"
          className="matches-mobile-filter-button"
          aria-label="Open filter and sort options"
          aria-expanded={mobileFiltersOpen}
          onClick={onToggleMobileFilters}
        >
          <TuneIcon />
        </button>
        {mobileFiltersOpen && (
          <div className="matches-mobile-filter-panel">
            <MatchesDropdown
              label="Filter By"
              value={appliedFilter}
              options={FILTER_MENU_OPTIONS}
              onChange={(next) => onFilterChange(next as FilterKey)}
            />
            <MatchesDropdown
              label="Sort By"
              value={sortOption}
              options={SORT_MENU_OPTIONS}
              onChange={(next) => onSortChange(next as SortKey)}
            />
          </div>
        )}
      </div>
    );
  }

  return (
    <div className="matches-toolbar">
      <div className="matches-filter-pills" aria-label="Match filters">
        {[
          { key: "all", label: "All", count: counts.all },
          { key: "loves", label: "Loves", count: counts.loves },
          { key: "likes", label: "Likes", count: counts.likes },
          { key: "not_for_me", label: "Not for Me", count: counts.notForMe },
          { key: "online", label: "Online", count: counts.online },
        ].map((pill) => (
          <button
            key={pill.key}
            type="button"
            className={`matches-pill ${appliedFilter === pill.key ? "is-active" : ""}`}
            onClick={() => onFilterChange(pill.key as FilterKey)}
            aria-pressed={appliedFilter === pill.key}
          >
            <span>{pill.label}</span>
            <span className="matches-pill-count">{pill.count}</span>
          </button>
        ))}
      </div>

      <div className="matches-toolbar-actions">
        <MatchesDropdown
          label="Filter By"
          value={appliedFilter}
          options={FILTER_MENU_OPTIONS}
          onChange={(next) => onFilterChange(next as FilterKey)}
        />
        <MatchesDropdown
          label="Sort By"
          value={sortOption}
          options={SORT_MENU_OPTIONS}
          onChange={(next) => onSortChange(next as SortKey)}
        />
      </div>
    </div>
  );
};
